import { useEffect, useState } from 'react';
import { BreezeLoadingDot } from 'ai-components-ui-library/components/loading/BreezeLoadingDot';
import { useIsDisabledByAccessControls } from '../internal/hooks/useIsDisabledByAccessControls';
import { CopilotPreviewDisabledState } from './CopilotPreviewDisabledState';
import { DisabledPreviewControls } from '../internal/DisabledPreviewControls';
import ErrorSectionFormatter from '../../conversational/internal/ErrorSectionFormatter';
import MissingHipaaAccess from './MissingHipaaAccess';
import { jsx as _jsx } from "react/jsx-runtime";
const STABILIZATION_DELAY = 500;
export const PreviewsEmptyStateWrapper = ({
  usageTracker,
  children,
  onDontShowAgain,
  overrideDisabled,
  previousGeneratedPreview,
  error,
  isHipaaPortal
}) => {
  const {
    isDisabledByAccessControls,
    isAccessRequestLoading
  } = useIsDisabledByAccessControls();

  /*
  This special case is needed because the overrideDisabled state is async.
  We need to wait for it to stabilize before we can render the preview.
  Otherwise, we will see a flash of the loading state.
   This is a workaround to avoid the flash between disabled and enabled states.
  */
  const [isWaitingForStabilization, setIsWaitingForStabilization] = useState(true);
  useEffect(() => {
    // Wait a short time on mount to let async overrideDisabled settle
    const timer = setTimeout(() => {
      setIsWaitingForStabilization(false);
    }, STABILIZATION_DELAY); // Small delay to let async state settle

    return () => clearTimeout(timer);
  }, []); // Empty dependency array since we only want this to run once on mount

  const isDisabled = (overrideDisabled === null || overrideDisabled === void 0 ? void 0 : overrideDisabled.isDisabled) || isDisabledByAccessControls;
  if (isAccessRequestLoading || isWaitingForStabilization) {
    return /*#__PURE__*/_jsx(BreezeLoadingDot, {});
  }
  if (isHipaaPortal) {
    return /*#__PURE__*/_jsx(MissingHipaaAccess, {});
  }
  if (error) {
    return /*#__PURE__*/_jsx(ErrorSectionFormatter, {});
  }
  if (isDisabled) {
    return /*#__PURE__*/_jsx(CopilotPreviewDisabledState, {
      overrideDisabled: overrideDisabled,
      previousGeneratedPreview: previousGeneratedPreview,
      children: /*#__PURE__*/_jsx(DisabledPreviewControls, {
        usageTracker: usageTracker,
        onDontShowAgain: onDontShowAgain,
        isDisabledDescriptionOverriden: Boolean(overrideDisabled === null || overrideDisabled === void 0 ? void 0 : overrideDisabled.disabledDescription)
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    children: children
  });
};